export default function ({ route, redirect }) {
  // Check if it's not the homepage and ends with a trailing slash
  if (route.fullPath !== '/' && route.fullPath.endsWith('/')) {
    const redirectUrl = route.fullPath.slice(0, -1);
    redirect(301, redirectUrl);
  }
}
